import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Modal } from "bootstrap";
export default function AmountModal({ agent, show, onClose, type, topAgent }) {
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const [amount, setAmount] = useState(0);
  const [memo, setMemo] = useState("");
  const modalRef = useRef(null);
  const modalInstance = useRef(null);

const handleSubmit = async () => {
  try {
    const token = localStorage.getItem("token");

    const params = new URLSearchParams({
      amount,
      memo,
      type,
      agent_id: agent.user_id,
      top_agent_id: topAgent.user_id,
    });

    await axios.get(`${API_BASE}/api/agentTransfer?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    alert("처리 완료되었습니다.");
    onClose();
  } catch (err) {
    console.error("지급/회수 실패:", err);
    alert("처리에 실패했습니다.");
  }
};
  const isDisabled =
  amount <= 0 ||
  (type === 0 && amount > topAgent.possess_amt) ||
  (type === 1 && amount > agent.possess_amt);

  useEffect(() => {
    if (modalRef.current && show) {
      modalInstance.current = new Modal(modalRef.current, {
        backdrop: "static",
        keyboard: true,
      });
      modalInstance.current.show();

      const handleHidden = () => {
        document.body.classList.remove("modal-open");
        const backdrop = document.querySelector(".modal-backdrop");
        if (backdrop) backdrop.remove();
        if (onClose) onClose();
      };

      modalRef.current.addEventListener("hidden.bs.modal", handleHidden);

      return () => {
        modalRef.current?.removeEventListener("hidden.bs.modal", handleHidden);
        modalInstance.current?.hide();
      };
    }
  }, [show]);

  

  return (
    <div
      className="modal fade show"
      style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
      tabIndex="-1"
      ref={modalRef}
      role="dialog"
      aria-modal="true"
    >
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              <i className="fas fa-dollar-sign" />{" "}
              {type === 0 ? "지급" : "회수"}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>

          <div className="modal-body">
            <p>
              에이전트 <strong>{agent.user_id}</strong> 님의 계좌에
              {type === 0 ? " 지급" : "서 회수"}합니다
            </p>

            <div className="row g-3">
              <div className="col-12">
                <label className="form-label">타입 구분</label>
                <select className="form-select">
                  <option value="cash">
                    알 {type === 0 ? "지급" : "회수"}
                  </option>
                </select>
              </div>

              <div className="col-12">
                <label className="form-label">보유금액</label>
                <input
                  className="form-control text-end"
                  readOnly
                  type="text"
                  value={
                    type === 0
                      ? topAgent.possess_amt.toLocaleString()
                      : agent.possess_amt.toLocaleString()
                  }
                />
              </div>

              <div className="col-12">
                <label className="form-label">{type ===0 ? "지급" : "회수"}금액</label>
                <div className="input-group">
                  <input
                    className="form-control text-end"
                    placeholder="0"
                    type="number"
                    value={amount}
                    onChange={(e) => setAmount(Number(e.target.value))}
                  />
                  <span className="input-group-text">KRW</span>
                  <button
                    className="btn btn-outline-danger"
                    onClick={() => setAmount(0)}
                  >
                    초기화
                  </button>
                </div>
              </div>

              <div className="col-12">
                <div className="btn-group mb-2 d-flex">
                  <button
                    className="btn btn-primary flex-fill"
                    onClick={() => setAmount((prev) => prev + 10000)}
                  >
                    10,000
                  </button>
                  <button
                    className="btn btn-primary flex-fill"
                    onClick={() => setAmount((prev) => prev + 100000)}
                  >
                    100,000
                  </button>
                  <button
                    className="btn btn-primary flex-fill"
                    onClick={() => setAmount((prev) => prev + 1000000)}
                  >
                    1,000,000
                  </button>
                </div>
                <div className="btn-group d-flex">
                  <button
                    className="btn btn-primary flex-fill"
                    onClick={() => setAmount((prev) => prev + 10000000)}
                  >
                    10,000,000
                  </button>
                  <button
                    className="btn btn-primary flex-fill"
                    onClick={() => setAmount((prev) => prev + 100000000)}
                  >
                    100,000,000
                  </button>
                </div>
              </div>

              <div className="col-12">
                <label className="form-label">MEMO</label>
                <textarea
                  className="form-control"
                  placeholder="메모"
                      value={memo}
    onChange={(e) => setMemo(e.target.value)}
                ></textarea>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button className="btn btn-primary"
                disabled={isDisabled}
    onClick={handleSubmit}>
              <em className="icon ni ni-tranx" />
              <span>{ type === 0 ? "지급하기" : "회수하기"}</span>
            </button>
            <button className="btn btn-outline-secondary" onClick={onClose}>
              <i className="icon fas fa-times" /> 취소
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
